import { V as VisuallyHidden } from './definition66.js';
import { L as Localized } from './localized.js';
import { a as attr, h as html } from './vivid-element.js';
import { r as ref } from './ref.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const WithCharCount = (Base) => {
  class ElementWithCharCount extends Localized(Base) {
    constructor() {
      super(...arguments);
      this.charCount = false;
      /**
       * Timeout of the character count update,
       * used to debounce screen reader announcements
       * @internal
       */
      this.#charCountTimeout = null;
      /**
       * ID of the character count limit description
       * @internal
       */
      this._charCountDescribedBy = "char-count-description";
      /**
       * @internal
       */
      this._renderCharCountRemaining = () => {
        if (!this.charCount || !this.maxlength) {
          return;
        }
        this.charCountRemaining.textContent = this.locale.charCount.charactersRemainingMessage(
          this.maxlength - this.value.length
        );
      };
      /**
       * @internal
       */
      this._updateCharCountRemaining = () => {
        const delay = 1e3;
        if (this.#charCountTimeout !== null) {
          clearTimeout(this.#charCountTimeout);
        }
        this.#charCountTimeout = setTimeout(
          () => this._renderCharCountRemaining(),
          delay
        );
      };
      /**
       * @internal
       */
      this._getCharCountTemplate = (context) => {
        const visuallyHiddenTag = context.tagFor(VisuallyHidden);
        return html`
				<div class="char-count">
					<span aria-hidden="true"
						> ${(x) => x.value ? x.value.length : 0} / ${(x) => x.maxlength}</span
					>
					<${visuallyHiddenTag} id="${(x) => x._charCountDescribedBy}"
						>${(x) => x.locale.charCount.charactersLimitMessage(
          x.maxlength
        )}</${visuallyHiddenTag}
					>
					<${visuallyHiddenTag} id="char-count-remaining" aria-live="polite" ${ref(
          "charCountRemaining"
        )}
						></${visuallyHiddenTag}
					>
				</div>
			`;
      };
    }
    #charCountTimeout;
  }
  __decorateClass([
    attr({
      attribute: "char-count",
      mode: "boolean"
    })
  ], ElementWithCharCount.prototype, "charCount");
  return ElementWithCharCount;
};

export { WithCharCount as W };
